import { __spreadValues } from './chunk-T36PI2YV.mjs';
import isNil from 'lodash/isNil';
import pickBy from 'lodash/pickBy';

var reduceErrors = (errors) => {
  return errors.reduce((prev, current) => {
    let newObj;
    try {
      newObj = typeof current === "object" ? current : JSON.parse(current);
    } catch (e) {
      newObj = {};
    }
    newObj = pickBy(newObj, (value) => !isNil(value));
    return __spreadValues(__spreadValues({}, prev), newObj);
  }, {});
};

export { reduceErrors };
